export default __webpack_public_path__ + "static/media/flayer55.77d080ba.jpg";